module.exports = __webpack_public_path__ + "img/product.1fc5c1ca.svg";